import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AdminForm from "../../AdminForm";
import { addTag } from "../tagsAdminSlice";

const fields = [
  {
    row: [
      {
        title: "Информация",
        data: [
          {
            required: true,
            options: undefined,
            type: "text",
            title: "Текст",
            name: "title",
          },
          {
            required: true,
            options: undefined,
            type: "text",
            title: "Тип",
            name: "type",
          },
          {
            required: true,
            options: undefined,
            type: "text",
            title: "Цвят на текста",
            name: "textColor",
          },
          {
            required: true,
            options: undefined,
            type: "text",
            title: "Фон HEX",
            name: "color",
          },
          {
            required: false,
            options: undefined,
            type: "text",
            title: "ICON",
            name: "icon",
          },
        ],
      },
    ],
  },
];

const AddTag = () => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    console.log(data);
    dispatch(
      addTag(data, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return (
    <AdminForm
      formTitle="Добавяне на таг"
      onSubmit={onSubmit}
      product={fields}
      progress={progress}
    />
  );
};

export default AddTag;
